import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import { MAX_VIDEO_REPLAYS } from './freeAnswerConstants';

export default function FreeAnswerMediaSection({
  hasVideo,
  hasImage,
  videoURL,
  imageURL,
  speech,
  videoPlaying,
  unmountVideoWhenDone,
  onVideoStart,
  onVideoDone,
  onImageLoadError,
}) {
  return (
    <div className="freeAnswer__media">
      <div className="freeAnswer__stimulus">
        <div className="freeAnswer__stimulusInner">
          {hasVideo && (
            <VideoPlayer
              videoURL={videoURL}
              text="Free Answer Video"
              unmountWhenDone={unmountVideoWhenDone}
              key="freeAnswerVideo"
              speech={speech}
              videoPlaying={videoPlaying}
              maxReplays={MAX_VIDEO_REPLAYS}
              onStart={onVideoStart}
              onDone={onVideoDone}
              useButtonLabels={false}
              useClearButtons={true}
            />
          )}
          {hasImage && !hasVideo && (
            <img
              src={imageURL}
              alt="Question prompt"
              onError={() => onImageLoadError?.(imageURL, imageURL)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
